/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Input from '@cashew/input';
import Button from '@cashew/button';
import { useEnterListener } from '@cashew/hooks';
import { useTranslation } from 'react-i18next';
import moment from 'moment/moment';
import CancelModal from './CancelModal';

import { MerchantData } from '../MerchantOnboarding/util';
import './index.css';
import SelectComponent from '../../components/SelectComponent';

const { api } = require('@cashew/utils');

const numericInput = /^[0-9]+$/;

export default ({
  setLoading,
  useSelector,
  setRecords,
  setList,
  pageSize,
  pageNumber,
  dispatch,
  setPageNumber,
  type,
}: any) => {
  const { t } = useTranslation();
  const { token } = useSelector((state: any) => state.user);
  const [searchId, setSearchId] = useState('');
  const [searchBy, setSearchBy] = useState<string>('merchantName');
  const [, setFilterParams] = useState();
  const [openSettings, setOpenSettings] = useState(false);
  const [enterBtn, setEnterBtn] = useState(false);

  const [reset, setReset] = useState(0);
  const [createdFrom, setCreatedFrom] = useState(
    moment().subtract(2, 'years').format('YYYY-MM-DD')
  );
  const [createdTo, setCreatedTo] = useState(moment().format('YYYY-MM-DD'));

  const [createdToError, setCreatedToError] = useState('');
  const [createdFromError, setCreatedFromError] = useState('');

  interface MerchantsResponse {
    status: string;
    data: MerchantData[];
    totalCount: number;
  }

  const searchByData = [
    {
      key: 'merchantId',
      value: 'Merchant ID',
    },
    {
      key: 'merchantName',
      value: 'Merchant name',
    },
  ];

  const getOrdersApi = (resetPageNumber = true) => {
    setLoading(true);

    if (resetPageNumber && pageNumber !== 0) {
      setPageNumber(0);
      return;
    }

    const params: any = {
      page: pageNumber,
      size: pageSize,
      createdFrom,
      createdTo,
    };
    if (searchId && searchBy) {
      params[searchBy] = searchId.trim();
    }
    setFilterParams(params);
    api
      .get({
        endpoint: 'identity/risk-rules',
        params,
        headers: {
          Authorization: token,
        },
      })
      .then((resp: MerchantsResponse) => {
        setList(resp.data);
        setRecords(resp.totalCount);
      })
      .catch(() =>
        dispatch({
          type: 'OPEN_TOASTER',
          payload: {
            toasterTitle: t('dispatches.error.fetchingList.title'),
            toasterMessage: t('dispatches.error.fetchingList.message'),
            toasterType: 'error',
            toasterVisible: true,
            toasterDismiss: null,
          },
        })
      )
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setSearchId('');
  }, [searchBy]);

  useEnterListener(() => setEnterBtn((prev) => !prev));

  useEffect(() => {
    getOrdersApi(false);
  }, [pageNumber, pageSize]);

  useEffect(() => {
    getOrdersApi(true);
  }, [createdFrom, createdTo, enterBtn]);

  return (
    <>
      <div className="filters">
        <div className="filter-group">
          <div className="filter-input">
            <SelectComponent
              label="Search by"
              data={searchByData}
              selected={searchBy}
              onSelect={setSearchBy}
            />
          </div>
          <div className="filter-input">
            <Input
              name="orderId"
              value={searchId}
              type="text"
              maxLength={searchBy === 'orderId' ? 14 : 100}
              onChange={(e: any) => {
                const searchValue = e.target.value;
                if (searchBy === 'merchantId') {
                  if (searchValue.match(numericInput) || searchValue === '') {
                    setSearchId(searchValue);
                  }
                } else {
                  setSearchId(searchValue);
                }
              }}
            />
          </div>
          <div className="filter-input">
            <button
              type="button"
              className="btn blue"
              onClick={() => {
                getOrdersApi(true);
              }}
            >
              Search
            </button>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-input">
            <label>From</label>
            <Input
              name="dateFrom"
              value={createdFrom}
              error={createdFromError ? ' ' : ''}
              type="date"
              onChange={(e: any) => {
                setCreatedToError('');
                setCreatedFrom(
                  moment(e.currentTarget.value).format('YYYY-MM-DD')
                );
                setReset(reset + 1);
                if (
                  moment(e.currentTarget.value).isAfter(createdTo) &&
                  createdTo
                ) {
                  setCreatedFromError(t('validation-less'));
                } else {
                  setCreatedFromError('');
                }
              }}
            />
            <span className="error-message">{createdFromError}</span>
          </div>
          <div className="filter-input">
            <span>To</span>
            <Input
              name="dateTo"
              value={createdTo}
              type="date"
              error={createdToError ? ' ' : ''}
              onChange={(e: any) => {
                setCreatedFromError('');
                setCreatedTo(
                  moment(e.currentTarget.value).format('YYYY-MM-DD')
                );
                setReset(reset + 1);
                if (
                  moment(e.currentTarget.value).isBefore(createdFrom) &&
                  createdFrom
                ) {
                  setCreatedToError(t('validation-greater'));
                } else {
                  setCreatedToError('');
                }
              }}
            />
            <span className="error-message">{createdToError}</span>
          </div>
        </div>
        <div className="filter-group">
          {type === 'cashew' && (
            <div className="filter-input">
              <Button onClick={() => setOpenSettings(true)}>
                Upload new risk rules
              </Button>
            </div>
          )}
        </div>
      </div>
      <CancelModal
        showConfirmModal={openSettings}
        setOpenSettings={setOpenSettings}
        afterUpload={getOrdersApi}
      />
    </>
  );
};
